var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCryptoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0576 15.9941H10.8702V13.8765C10.6159 13.9038 10.3451 13.9228 10.0576 13.9345V15.9941Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69722 5.70898H5.44092V6.77839H7.41956L7.69722 5.70898Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41956 12.8721H5.44092V13.9415H7.77165L7.41956 12.8721Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58427 3.50293H7.77173V15.9947H8.58427V3.50293Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8077 9.49566V9.47122C12.9577 9.15598 13.6542 8.4642 13.6542 7.67537C13.6542 7.03212 13.3142 6.54686 12.7472 6.23162C12.2674 5.94046 11.6731 5.76496 10.8704 5.68506V6.53445C11.7081 6.69353 12.2291 7.08211 12.2291 7.78374C12.2291 8.37372 11.7398 8.84767 10.8704 9.0498V10.0513C11.8635 10.2371 12.5692 10.7044 12.5692 11.5334C12.5692 12.4091 11.8383 12.8575 10.8704 13.0326V13.8762C11.8653 13.7696 12.6122 13.5427 13.1361 13.1837C13.6871 12.7834 14.0596 12.2485 14.0596 11.5455C14.0596 10.3327 12.8446 9.68977 11.8081 9.4953H11.8077V9.49566Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.422302,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17529 5.80725V13.8524C7.90173 13.9298 8.63182 13.9623 9.36227 13.9495C10.1168 13.9364 10.8699 13.8751 11.6167 13.766C11.161 13.8776 10.8027 13.6634 10.7703 13.4653C10.7403 13.2829 10.9706 13.006 11.3588 12.9144C11.0198 12.9928 10.6761 13.0501 10.3302 13.0855C10.0752 13.1114 9.87417 13.1223 9.76726 13.1242C9.37248 13.13 8.9777 13.114 8.58475 13.0756V9.95718H9.75048C9.90007 9.95244 10.0624 9.95426 10.2361 9.96594C10.493 9.98345 10.748 10.0214 10.999 10.079L10.8702 9.05123C10.6728 9.10122 10.4711 9.13406 10.2679 9.14938C10.1332 9.1596 9.99822 9.16215 9.86359 9.15668H8.58475V6.52348C9.34366 6.42059 10.1132 6.4246 10.871 6.53625C10.8367 6.2502 10.8027 5.96451 10.7688 5.67846C10.443 5.65547 10.1037 5.64124 9.75121 5.63759C8.88941 5.62884 8.0287 5.68576 7.17566 5.80725H7.17529Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.422302,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8704 3.50293H10.0579V5.64065C10.3508 5.64649 10.6208 5.66181 10.8704 5.68626V3.50329V3.50293Z",
    fill: "#F39200",
    stroke: "#F39200",
    strokeWidth: 0.351918,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3869 33.1119C7.94675 32.9481 6.78394 31.5722 6.71826 29.5414H8.17588C8.25797 30.9333 9.09314 31.8013 10.8948 31.8013C12.5655 31.8013 13.5317 31.1464 13.5317 29.8358C13.5317 28.7223 12.8928 28.2308 11.6483 27.9688L9.97756 27.6084C8.15946 27.2154 7.11122 26.2653 7.11122 24.5129C7.11122 22.7604 8.32328 21.5648 10.3866 21.3846V20.0415H11.5001V21.401C13.4821 21.6141 14.8087 22.9239 14.8247 24.7748H13.3671C13.3014 23.5303 12.4827 22.7112 10.8777 22.7112C9.51857 22.7112 8.58489 23.3008 8.58489 24.5129C8.58489 25.4462 9.15809 25.9377 10.3702 26.216L11.9259 26.5765C13.8914 27.0352 15.0214 27.9524 15.0214 29.8358C15.0214 31.7192 13.6455 32.9149 11.5001 33.0951V34.4546H10.3866V33.1115H10.3869V33.1119Z",
    fill: "#F39200"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8869 10.2095L21.3528 15.9776L25.8869 18.3028L30.5374 15.9776L25.8869 10.2095Z",
    fill: "#F39200"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3528 17.4888L25.9449 19.698L30.5374 17.4888L25.9449 24.3058L21.3528 17.4888Z",
    fill: "#F39200"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75009 18.4997C14.5826 18.4997 18.5002 14.5821 18.5002 9.7496C18.5002 4.91706 14.5826 0.999512 9.75009 0.999512C4.91755 0.999512 1 4.91706 1 9.7496C1 14.5821 4.91755 18.4997 9.75009 18.4997Z",
    stroke: "#29ABE2",
    strokeWidth: 0.879795,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9454 26.007C30.7779 26.007 34.6955 22.0895 34.6955 17.2569C34.6955 12.4244 30.7779 8.50684 25.9454 8.50684C21.1129 8.50684 17.1953 12.4244 17.1953 17.2569C17.1953 22.0895 21.1129 26.007 25.9454 26.007Z",
    stroke: "#29ABE2",
    strokeWidth: 0.879795,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2269 35.9997C16.0594 35.9997 19.977 32.0821 19.977 27.2496C19.977 22.4171 16.0594 18.4995 11.2269 18.4995C6.39436 18.4995 2.47681 22.4171 2.47681 27.2496C2.47681 32.0821 6.39436 35.9997 11.2269 35.9997Z",
    stroke: "#29ABE2",
    strokeWidth: 0.879795,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoIcon);
export default __webpack_public_path__ + "static/media/cryptoIcon.8a19305325488965a94f54f55d313418.svg";
export { ForwardRef as ReactComponent };